import { BASE_URL } from '../../../../../utils/config.base-url'

export const CUSTOM_FIELD_PREFIX_URL = '/custom-field'
export const URL_ENDPOINT_CUSTOM_FIELD = `${BASE_URL}/custom-field`

export const CUSTOM_FIELD_SOFT_LIMIT_QUANTITY = 100
